// extracted by css-extract-rspack-plugin
var _1 = "footer-Jk5efk";
var _2 = "form-WcX5X0";
var _3 = "header-bGDB47";
var _4 = "layout-AJLquH";
var _5 = "logo-NNyCTa";
export { _1 as "footer", _2 as "form", _3 as "header", _4 as "layout", _5 as "logo" }
